import { defaultProps } from 'recompose';

import Viewport from '@/components/Map/Viewport';

import MapTransformer from './MapTransformer';

export default defaultProps({ MapTransformer })(Viewport);
